import './theme-init'
import ReactDom from 'react-dom'
import App from './App'
import './index.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


ReactDom.render(<App/>, document.querySelector("#root"))